var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.256836C21.4146 0.256836 25.3997 4.2294 25.3997 9.62692C25.3997 15.0244 21.4091 18.997 16 18.997C10.5909 18.997 6.60034 15.0244 6.60034 9.62692C6.60034 4.2294 10.5909 0.256836 16 0.256836ZM0 30.7852C2.81015 26.6615 7.49915 23.9141 12.865 23.9141H19.135C24.5063 23.9141 29.1898 26.6615 32 30.7852C27.9932 35.06 22.3134 37.7425 16 37.7425C9.68663 37.7425 4.00677 35.0546 0 30.7852Z",
    fill: "#35373A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.9b519c86a164a31c7e16a76f8d730dd2.svg";
export { ForwardRef as ReactComponent };